import styled, { css, keyframes } from "styled-components";

import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const fadeUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(150px);
  }

  100% {
    opacity: 1;
  }
`;

const container = styled.div<{ sectionBackgroundColor: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 80px 0 124px 0;
  background-color: ${({ sectionBackgroundColor }) => sectionBackgroundColor};

  ${mobile(css`
    padding: 48px 16px;
    align-items: flex-start;
  `)};

  > h3 {
    margin-top: 16px;
  }

  .fade-up-animation {
    opacity: 0;

    &.active {
      animation-name: ${fadeUp};
      animation-duration: 0.8s;
      animation-timing-function: ease-in-out, cubic-bezier(0.65, 0, 0.35, 1);
      animation-fill-mode: forwards;
    }
  }
`;

const sliderList = styled.div<{ sliderBackgroundColor: string }>`
  width: 100%;
  max-width: 1128px;
  margin-top: 32px;
  background-color: ${COLOR.wh};
  animation-delay: 0.4s;
  background-color: ${({ sliderBackgroundColor }) => sliderBackgroundColor};

  ${mobile(css`
    max-width: 100%;
  `)};
`;

const slider = styled.div`
  display: flex;

  ${mobile(css`
    flex-direction: column;
  `)};
`;

const contents = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px 24px 24px;
  flex: 0 0 808px;

  ${mobile(css`
    flex: 0 0 auto;
    padding: 24px 16px;
    animation-delay: 0.6s;
  `)};

  .desc {
    flex: 1;
    margin-top: 16px;
    ${setFontStyle("Body1")};
    color: ${TEXT_COLOR.black_2};
  }
`;

const contentsHeader = styled.div`
  display: flex;
  justify-content: space-between;

  .title {
    ${setFontStyle("SubHead3")};
    color: ${TEXT_COLOR.black_3};
  }
`;

const pagination = styled.div`
  display: flex;
  align-self: flex-end;
  align-items: center;
  gap: 16px;
  ${setFontStyle("Body2")};
  color: ${TEXT_COLOR.black_2};

  ${mobile(css`
    margin-top: 24px;
  `)};

  > svg {
    cursor: pointer;
  }
`;

export default {
  container,
  sliderList,
  slider,
  contents,
  contentsHeader,
  pagination,
};
